import { createAnalyticsService, createGTMService } from '@investown/fe/common-utils';

import { createBloomreachWebAnalyticsService } from 'analytics/bloomreach/bloomreachService';

const analyticsService = createAnalyticsService([createGTMService(), createBloomreachWebAnalyticsService()]);

export default analyticsService;
